import {
  Button,
  Card,
  Grid,
  Icon,
  List,
  Modal,
  NavBar,
  SearchBar,
  Tabs,
  Toast,
  WhiteSpace,
  WingBlank,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../util/axios";
const HomePage = styled.div`
  .bg {
    background-color: red;
  }
  .body {
    // width:100%;
    // padding: 0 10px 0 10px;
  }
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  ul li {
    margin-top: 5px;
    border-bottom: 1px solid #d7d7d7;
  }
  .notice {
    width: 100%;
    height: 220px;
  }
  .notice_title {
    display: flex;
    justify-content: space-between;
    height: 40px;
    align-items: center;
  }
  .s1 {
    margin-left: 30px;
    // width: 130px;
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }
  .s2 {
    margin-right: 10px;
  }
`;
interface Array1 {}
interface Array2 {}
export default function MoreNoticeList() {
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });
  const history = useHistory();
  const [noticeList, setNoticeList] = useState<Array1[]>([]);
  const [announcementList, setAnnouncementList] = useState<Array2[]>([]);
  const tabs = [{ title: "通知" }, { title: "通告" }];
  useEffect(() => {
    instance.get(`/oa/releaseNotice/getReleaseNewSyGg`).then((resp) => {
      // console.log(resp)
      setNoticeList(resp.data.Data);
      console.log(resp.data.Data);
    });
  }, []);
  useEffect(() => {
    instance.get(`/oa/releaseNew/getReleaseNewSy`).then((resp) => {
      // console.log(resp);
      setAnnouncementList(resp.data.Data);
      console.log(resp.data.Data);
    });
  }, []);
  return (
    <>
      <HomePage>
        <div className="body">
          <NavBar
            className="orderNavBar bg"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  // history.push(`/hr/rankadjustment`);
                  history.go(-1);
                }}
              />
            }
          >
            通知通告
          </NavBar>
          <WhiteSpace />
          <Tabs tabs={tabs} initialPage={"t2"}>
            {/* 通知 */}
            <div
              style={{
                backgroundColor: "#fff",
                padding: "10px 20px 10px 20px",
              }}
              className="month"
            >
              <ul>
                {noticeList.map((item: any) => (
                  <li
                    onClick={() => {
                      // window.location.href =
                      //   "/hr/rankadjustment/promotionmanagement/details";
                    }}
                  >
                    <p>{item.title}</p>
                    <p>
                      <span>{item.departName}</span>
                      <span className="s1">{item.createTime}</span>
                    </p>
                  </li>
                ))}
              </ul>
            </div>
            {/* 通告 */}
            <div
              style={{
                backgroundColor: "#fff",
                padding: "10px 20px 10px 20px",
              }}
              className="month"
            >
              <ul>
                {announcementList.map((item: any) => (
                  <li
                    onClick={() => {
                      // window.location.href =
                      //   "/hr/rankadjustment/promotionmanagement/details";
                    }}
                  >
                    <p>{item.title}</p>
                    <p>
                      <span>{item.departName}</span>
                      <span className="s1">{item.createTime}</span>
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </Tabs>
        </div>
      </HomePage>
    </>
  );
}
